<template>
	<Container>
		<TopBar/>
		<div class="items">
			<div class="item" v-for='(article,index1) in items'>
				<p class="title">{{article.Title}}</p>
				<p class="datetime">{{article.CreateTime | dateFormat}}</p>
				<!-- <p class="content">{{article.SubTitle | noHTML}}</p> -->
				<a @click='goDetail(article)' class="button-primary detail">{{article.Flag2 || '查看详情'}}</a>
			</div>
		</div>
		<LoadMore v-lazyFunc='searchMoreArticle' v-if='articlesLoading'/>
		
	</Container>
</template>

<script>
	import TopBar from '@/components/common/TopBar'
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	export default {
		data() {
			return {
				items:[],
				articlesLoading:false,
				pageIndex:1,
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{
			'$route'(value){
				this.initData()
			},
		},
		mixins:[],
		components: {
			TopBar,
		},
		computed: {
			...mapState({

			}),
		},
		methods: {
			...mapActions([
				'getCommunityListAction',
			]),
			async initData(){
				let code = this.$route.query?.code
				let depth = this.$route.query?.depth || 1
				let params = {
					code,
					depth,
					keys: '',
					StartIndex: 1,
					PageSize: 20,
				}
				let response = await this.getCommunityListAction(params)
				this.articlesLoading = response.length >= 20
				this.items = response
			},
			async searchMoreArticle(){
				this.pageIndex += 20
				let code = this.$route.query?.code
				let depth = this.$route.query?.depth || 1
				let params = {
					code,
					depth,
					keys: '',
					StartIndex: this.pageIndex,
					PageSize: 20,
				}
				this.articlesLoading = false
				let response = await this.getCommunityListAction(params)
				if (response.length >= 20)  this.articlesLoading = true
				this.items = [...this.items,...response]

			},
			goDetail(item){
				this.$router.push({
					path:'/culture/article',
					query:{
						code:item.Code
					}
				})
			}
		},
	}
</script>

<style lang='scss' scoped>
	@import '@/style/common';
	@import '@/style/mixin';
	.items {
		margin: auto;
		// max-width: 1560px;
		margin: 0 10vw;
		margin-top: 40px;
		.item {
			margin-bottom: 40px;
			border-bottom: 1px solid #eee;
			.title {
				color:$theme-color;
				@include fontSize($font-size-18);
				margin-bottom: 5px;
			}
			.datetime,.content {
				margin-bottom: 5px;
			}
			.datetime {
				// max-width: 100px;
			}
			.detail {
				display: inline-block;
				padding: 3px 10px;
				border-radius: 20px;
				margin-top: 20px;
				margin-bottom: 20px;
			}
		}
	}
</style>